import { FormInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketAutoTransferRuleForm } from "./TicketAutoTransferRuleSchema";

const translationPath = "page.settings.crm.ticketAutoTransferRules.";

const Message = () => {
  const { t } = useTranslation();

  const { control, setValue, getValues } =
    useFormContext<TTicketAutoTransferRuleForm>();

  const transfer = useWatch({
    name: "transfer",
    control,
  });

  useEffect(() => {
    if (transfer) {
      setValue(
        "message",
        getValues("message")
          ? getValues("message")
          : "Seu atendimento foi transferido por estar muito tempo sem sua interação, se precisar retomar esta conversa informe aos nossos atendentes o número de protocolo {{protocolNumber}}."
      );
    } else {
      setValue("message", "");
    }
  }, [setValue, getValues, transfer]);

  return (
    <>
      {transfer && (
        <Grid item xs={12} sm={12}>
          <FormInput
            size="small"
            name="message"
            fullWidth
            label={t(translationPath + "message") || "Message"}
            multiline
            minRows={4}
          />
          <Typography variant="body2">
            {t(translationPath + "message_helper")}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default Message;
